const SpanStatusCode = {
  UNSET: 0,
  OK: 1,
  ERROR: 2,
};
export default SpanStatusCode;
